import {Button, ConfigProvider} from "antd";
import {Link, useNavigate} from "react-router-dom";
import {deleteWorkforceCase} from "../../Services/workforce";
import {useDispatch} from "react-redux";
import {SET_IS_API_CALLED, SET_IS_API_CALLED_FINISHED} from "../../store/features/loadingSlice";
import dayjs from "dayjs";
import { clientColumnSorter } from "../../utils/tableClientSort";

export const CaseListingTableHeaders = (setShowNotifyActionsOnRecordModal,setDeletedRecord) => {
    return [
        {
            title: "No",
            dataIndex: "id",
            sorter: clientColumnSorter("id"),
        },
        {
            title: "Case ID",
            dataIndex: "caseIdStr",
            sorter: clientColumnSorter("caseIdStr"),
            // defaultSortOrder: "descend",
            // sorter: (a, b) => a.caseIdStr - b.caseIdStr,
            render: (text) => {
                return (
                    <>
                        <p>{(text !== null) ? text : "NA"}</p>
                    </>
                );
            },
        },
        {
            title: "Case Type",
            dataIndex: "caseType",
            filters: [
                {text: "Alarm", value: "Alarm"},
                {text: "Meter Replacement", value: "Meter Replacement"},
                {text: "Logger Replacement", value: "Logger Replacement"},
                {text: "Sim-Card Replacement", value: "Sim-Card Replacement"},
                {text: "Meter Inspection", value: "Meter Inspection"},
                {text: "Clamp-On", value: "Clamp-On"},
                {text: "Download Data", value: "Download Data"},
                {text: "Manual Read", value: "Manual Read"},
            ],
            onFilter: (value, record) => record.caseType.toString().includes(value),
            sorter: clientColumnSorter("caseType"),
            sortDirections: ["descend", "ascend"],
            render: (text) => {
                return (
                    <>
                        <p>{(text !== null) ? text : "NA"}</p>
                    </>
                );
            },
        },
        {
            title: "Meter S/N",
            dataIndex: "meterSerialNumber",
            sorter: clientColumnSorter("meterSerialNumber"),
            render: (text) => {
                return (
                    <>
                        <p>{(text !== null) ? text : "NA"}</p>
                    </>
                );
            },
        },
        {
            title: "Alarm Type",
            dataIndex: "alarmType",
            filters: [
                {text: "alarm1", value: "alarm1"},
                {text: "alarm2", value: "alarm2"},
            ],
            onFilter: (value, record) => record.name.indexOf(value) === 0,
            sorter: clientColumnSorter("alarmType"),
            sortDirections: ["descend", "ascend"],
            render: (text) => {
                return (
                    <>
                        <p>{(text !== null) ? text : "NA"}</p>
                    </>
                );
            },
        },
        {
            title: "Case Date Created",
            dataIndex: "createdAt",
            sorter: clientColumnSorter("createdAt"),
            render: (text) => {
                const createdAtValue = dayjs(text).format('DD/MM/YYYY HH:mm A');

                return (
                    <>
                        <p>{(text !== null) ? createdAtValue : "NA"}</p>
                    </>
                );
            },
        },
        {
            title: "Created By",
            dataIndex: "createdBy",
            sorter: clientColumnSorter("createdBy"),
        },
        {
            title: "Case Status",
            dataIndex: "caseStatus",
            filters: [
                {text: "alarm1", value: "alarm1"},
                {text: "alarm2", value: "alarm2"},
            ],
            onFilter: (value, record) => record.name.indexOf(value) === 0,
            sorter: clientColumnSorter("caseStatus"),
            render: (text) => {
                return (
                    <>
                        <p>{(text !== null) ? text : "NA"}</p>
                    </>
                );
            },
        },
        {
            title: "Region",
            dataIndex: "region",
            filters: [
                {text: "alarm1", value: "alarm1"},
                {text: "alarm2", value: "alarm2"},
            ],
            onFilter: (value, record) => record.name.indexOf(value) === 0,
            sorter: clientColumnSorter("region"),
            render: (text) => {
                return (
                    <>
                        <p>{(text !== null) ? text : "NA"}</p>
                    </>
                );
            },
        },
        {
            title: "Device Installation Date",
            dataIndex: "installationDate",
            sorter: clientColumnSorter("installationDate"),
            render: (text) => {
                const installationDateValue = dayjs(text).add(dayjs().utcOffset()).format('DD/MM/YYYY HH:mm A');

                return (
                    <>
                        <p>{(text !== null) ? installationDateValue : "NA"}</p>
                    </>
                );
            },
        },
        {
            title: "Assign To",
            dataIndex: "assignTo",
            sorter: clientColumnSorter("assignTo"),
            render: (text) => {
                return (
                    <>
                        <p>{(text !== null) ? text : "NA"}</p>
                    </>
                );
            },
        },
        {
            title: "Geocode",
            dataIndex: "geoCode",
            sorter: clientColumnSorter("geoCode"),
            render: (text) => {
                return (
                    <>
                        <p>{(text !== null) ? text : "NA"}</p>
                    </>
                );
            },
        },
        {
            title: "",
            dataIndex: "action",
            render: (text, record) => {
                return (
                    <>
                        <div className={"flex flex-col gap-3"}>
                            <NavigationButton record={record}/>
                            <Button color="danger" variant="solid" onClick={() => {
                                setShowNotifyActionsOnRecordModal(true);
                                setDeletedRecord(record);
                            }} className="text-white shadow-md border rounded">
                                Delete
                            </Button>
                        </div>
                    </>
                );
            },
        },
    ]
}

const NavigationButton = ({record}) => {
    const navigate = useNavigate();
    return (
        <ConfigProvider
            theme={{
                token: {
                    borderRadius: 2,
                    colorBorder: "transparent",
                    boxShadow: "0 0 #0000",
                    colorPrimaryText: "blue",
                },
            }}
        >
            <Button
                onClick={() => navigate(`/wf-case-listing-details/${record?.id}`)}
                className="text-medium-blue-100 shadow-md border-slate-600 rounded"
            >
                View
            </Button>
        </ConfigProvider>
    );
};

export const CaseDashboardTableHeaders = [
    {
        title: "No",
        dataIndex: "id",
        width: 100,
        sorter: clientColumnSorter("id"),
    },
    {
        title: "Region",
        dataIndex: "name",
        sorter: clientColumnSorter("name"),
        render: (text) => {
            return (
                <>
                    <p className="text-black">{text !== "" ? text : "NA"}</p>
                </>
            );
        },
    },
    {title: "Pending", dataIndex: "pendingCount", width: 200, align: 'center', sorter: clientColumnSorter("pendingCount")},
    {title: "Resolved", dataIndex: "resolvedCount", width: 200, align: 'center', sorter: clientColumnSorter("resolvedCount")},
    {title: "Completed", dataIndex: "completedCount", width: 200, align: 'center', sorter: clientColumnSorter("completedCount")},
];

export const CaseDashboardTechnicianTableHeaders = [
    {
        title: "No",
        dataIndex: "id",
        width: 100,
        sorter: clientColumnSorter("id"),
    },
    {
        title: "Team",
        dataIndex: "name",
        sorter: clientColumnSorter("name"),
    },
    {title: "Pending", dataIndex: "pendingCount", width: 200, align: 'center', sorter: clientColumnSorter("pendingCount")},
    {title: "Resolved", dataIndex: "resolvedCount", width: 200, align: 'center', sorter: clientColumnSorter("resolvedCount")},
    {title: "Completed", dataIndex: "completedCount", width: 200, align: 'center', sorter: clientColumnSorter("completedCount")},
];

export const TechnicianListingTableHeaders = [
    {
        title: "No",
        dataIndex: "id",
        sorter: clientColumnSorter("id"),
    },
    {
        title: "Team",
        dataIndex: "name",
        // defaultSortOrder: "descend",
        sorter: clientColumnSorter("name"),
    },
    {
        title: "Region",
        dataIndex: "region",
        sorter: clientColumnSorter("region"),
    },
];

export const TechnicianListingTableHeadersPending = [
    {
        title: "Alarm Pending",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.alarm.pending}`,
        sorter: (a, b) => a.caseCountByCaseType?.alarm.pending - b.caseCountByCaseType?.alarm.pending,
    },
    {
        title: "Meter Replacement Pending",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.meterReplacement.pending}`,
        sorter: (a, b) => a.caseCountByCaseType.meterReplacement.pending - b.caseCountByCaseType.meterReplacement.pending,
    },
    {
        title: "Logger Replacement Pending",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.loggerReplacement.pending}`,
        sorter: (a, b) => a.caseCountByCaseType.loggerReplacement.pending - b.caseCountByCaseType.loggerReplacement.pending,
    },
    {
        title: "Simcard Replacement Pending",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.simCardReplacement.pending}`,
        sorter: (a, b) => a.caseCountByCaseType.simCardReplacement.pending - b.caseCountByCaseType.simCardReplacement.pending,
    },
    {
        title: "Meter Inspection Pending",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.meterInspection.pending}`,
        sorter: (a, b) => a.caseCountByCaseType.meterInspection.pending - b.caseCountByCaseType.meterInspection.pending,
    },
    {
        title: "Clamp On Pending",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.clampOn.pending}`,
        sorter: (a, b) => a.caseCountByCaseType.clampOn.pending - b.caseCountByCaseType.clampOn.pending,
    },
    {
        title: "Download Data Pending",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.downloadData.pending}`,
        sorter: (a, b) => a.caseCountByCaseType.downloadData.pending - b.caseCountByCaseType.downloadData.pending,
    },
    {
        title: "Manual Read Pending",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.manualRead.pending}`,
        sorter: (a, b) => a.caseCountByCaseType.manualRead.pending - b.caseCountByCaseType.manualRead.pending,
    },
]

export const TechnicianListingTableHeadersCompleted = [
    {
        title: "Alarm Completed",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.alarm.completed}`,
        sorter: (a, b) => a.caseCountByCaseType.alarm.completed - b.caseCountByCaseType.alarm.completed,
    },
    {
        title: "Meter Replacement Completed",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.meterReplacement.completed}`,
        sorter: (a, b) => a.caseCountByCaseType.meterReplacement.completed - b.caseCountByCaseType.meterReplacement.completed,
    },
    {
        title: "Logger Replacement Completed",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.loggerReplacement.completed}`,
        sorter: (a, b) => a.caseCountByCaseType.loggerReplacement.completed - b.caseCountByCaseType.loggerReplacement.completed,
    },
    {
        title: "Simcard Replacement Completed",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.simCardReplacement.completed}`,
        sorter: (a, b) => a.caseCountByCaseType.simCardReplacement.completed - b.caseCountByCaseType.simCardReplacement.completed,
    },
    {
        title: "Meter Inspection Completed",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.meterInspection.completed}`,
        sorter: (a, b) => a.caseCountByCaseType.meterInspection.completed - b.caseCountByCaseType.meterInspection.completed,
    },
    {
        title: "Clamp On Completed",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.clampOn.completed}`,
        sorter: (a, b) => a.caseCountByCaseType.clampOn.completed - b.caseCountByCaseType.clampOn.completed,
    },
    {
        title: "Download Data Completed",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.downloadData.completed}`,
        sorter: (a, b) => a.caseCountByCaseType.downloadData.completed - b.caseCountByCaseType.downloadData.completed,
    },
    {
        title: "Manual Read Completed",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.manualRead.completed}`,
        sorter: (a, b) => a.caseCountByCaseType.manualRead.completed - b.caseCountByCaseType.manualRead.completed,
    },
]

export const TechnicianListingTableHeadersCancelled = [
    {
        title: "Alarm Cancelled",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.alarm.cancelled}`,
        sorter: (a, b) => a.caseCountByCaseType.alarm.cancelled - b.caseCountByCaseType.alarm.cancelled,
    },
    {
        title: "Meter Replacement Cancelled",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.meterReplacement.cancelled}`,
        sorter: (a, b) => a.caseCountByCaseType.meterReplacement.cancelled - b.caseCountByCaseType.meterReplacement.cancelled,
    },
    {
        title: "Logger Replacement Cancelled",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.loggerReplacement.cancelled}`,
        sorter: (a, b) => a.caseCountByCaseType.loggerReplacement.cancelled - b.caseCountByCaseType.loggerReplacement.cancelled,
    },
    {
        title: "Simcard Replacement Cancelled",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.simCardReplacement.cancelled}`,
        sorter: (a, b) => a.caseCountByCaseType.simCardReplacement.cancelled - b.caseCountByCaseType.simCardReplacement.cancelled,
    },
    {
        title: "Meter Inspection Cancelled",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.meterInspection.cancelled}`,
        sorter: (a, b) => a.caseCountByCaseType.meterInspection.cancelled - b.caseCountByCaseType.meterInspection.cancelled,
    },
    {
        title: "Clamp On Cancelled",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.clampOn.cancelled}`,
        sorter: (a, b) => a.caseCountByCaseType.clampOn.cancelled - b.caseCountByCaseType.clampOn.cancelled,
    },
    {
        title: "Download Data Cancelled",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.downloadData.cancelled}`,
        sorter: (a, b) => a.caseCountByCaseType.downloadData.cancelled - b.caseCountByCaseType.downloadData.cancelled,
    },
    {
        title: "Manual Read Cancelled",
        dataIndex: "caseCountByCaseType",
        render: (caseCountByCaseType) => `${caseCountByCaseType.manualRead.cancelled}`,
        sorter: (a, b) => a.caseCountByCaseType.manualRead.cancelled - b.caseCountByCaseType.manualRead.cancelled,
    },
]

export const EDITABLE_CASE_STATUS = [1, 2, 3];
export const CANCELLABLE_CASE_STATUS = [2, 3, 4, 5, 6];
export const DRAFTABLE_CASE_STATUS = [1, 3];
export const DISABLED_BEFORE_AFTER_CASE_TYPES = ["Alarm", "Download Data", "Manual Read"]
